<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-form ref="form" lazy-validation>
      <div v-if="edicao === 'false' || !edicao" class="text-h4 mb-7">
        Cadastro de Grupo de Expressões
      </div>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="form.description"
            :counter="30"
            label="Descrição"
            outlined
            :error-messages="descriptionErrors"
            @input="
              $v.form.description.$touch();
              form.description = $event.trim();
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-file-input
            outlined
            dense
            show-size
            accept="text/csv"
            label="Insira seu Arquivo"
            hint="Apenas arquivos csv"
            persistent-hint
            v-model="form.import"
            prepend-icon=""
            append-icon="mdi-paperclip"
          />
        </v-col>
      </v-row>
      <v-row v-for="n in qtdRegex" :key="n" align="baseline" dense>
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            label="Regex"
            v-model="form.regex[n - 1]"
            :rules="rules"
            @keyup.enter="novaRegex"
          />
        </v-col>
        <v-col cols="2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark icon color="bluePcm" v-bind="attrs" v-on="on" @click="novaRegex">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Nova Regex</span>
          </v-tooltip>
          <v-tooltip top v-if="n - 1 !== 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small dark icon color="darkRed" v-bind="attrs" v-on="on" @click="removeRegex(n - 1)">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover Regex</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <div v-for="n in 4" :key="n + 100">
        <v-divider dark vertical />
      </div>

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import regexsStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import regexHttpService from '../_services/regexHttpService'

export default {
  name: 'CadastroRegex',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],

  data: () => ({
    text: '',
    snackbar: false,
    showSkeleton: false,
    form: {
      description: '',
      import: null,
      regex: [],
    },
    qtdRegex: 1,
    rules: [value => /^[\dXs#?*+\-[\]]{1,20}.{0,1}$/g.test(value) || /^.$/.test(value) || !value || 'Regex inválida'],
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('cadastroRegexModulePABXStore', ['getRegex']),
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroRegexModulePABXStore', regexsStore)

    if (this.edicao === 'true') {
      this.form.description = this.getRegex.description
      this.qtdRegex = this.getRegex.regexsVisual.length
      this.form.regex = this.getRegex.regexsVisual
    }
  },

  methods: {
    novaRegex() {
      this.qtdRegex = this.qtdRegex + 1
    },
    removeRegex(key) {
      this.qtdRegex = this.qtdRegex - 1
      this.form.regex.splice(key, 1)
    },
    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      if (this.form.import === null) {
        if (
          this.form.regex.length === 0 ||
          (this.form.regex.length === 1 && !this.form.regex[0]) ||
          (this.form.regex.length === 1 && this.form.regex[0] === ' ')
        ) {
          this.text = 'Insira ao menos uma expressão regular ou um arquivo com expressões para poder salvar.'
          this.pararLoader.parar = true
          this.snackbar = true
          return
        } else if (this.form.regex.length > 1) {
          this.form.regex.forEach((reg, key) => {
            if (!reg || reg === ' ') {
              this.text = `Insira uma regex válida na linha ${key + 1}`
              this.snackbar = true
              this.pararLoader.parar = true
              throw new Error()
            }
          })
        }
      }
      try {
        if (this.edicao === 'true') {
          await regexHttpService.putRegex(this._id, this.form)
        } else {
          await regexHttpService.postRegex(this.form)
        }

        this.$router.push({ name: 'Aliasregex' })
      } catch (error) {
        console.log(error.data)

        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },

    cancelar() {
      this.$router.push({ name: 'Aliasregex' })
    },
  },
}
</script>
